// extracted by mini-css-extract-plugin
module.exports = {"thumbnailImage":"Thumbnail_thumbnailImage__h3bf7","bigTile":"Thumbnail_bigTile__uPK7G"};